export const DAYS_AFTER_TOOLKIT = "This category will include all users who have completed registration within the number of days you specify."

export const VALIDATION = {
    positive_number: 'Please enter a positive number'
}